import React, { useEffect } from 'react';
import { FunButton } from './GameUI';

export function pictureSetCounts(source) {
  if (!source) return null;
  const total = source.picture_count;
  const premium = source.premium_picture_count;
  if (total == null && premium == null) return null;
  const basic = source.basic_picture_count != null
    ? source.basic_picture_count
    : (total != null && premium != null ? total - premium : null);
  return {
    basic,
    total,
    premium: premium == null ? null : premium,
  };
}

export function pictureSetLabel(source) {
  const counts = pictureSetCounts(source);
  if (!counts || !counts.premium) return null;
  if (source.picture_set === 'extended') {
    return counts.total != null ? `Extended pack · all ${counts.total}` : 'Extended pack';
  }
  return counts.basic != null ? `Basic pack · ${counts.basic} pictures` : 'Basic pack';
}

function countLabel(count, fallback) {
  if (count == null) return fallback;
  return count === 1 ? '1 picture' : `${count} pictures`;
}

const PictureSetPicker = ({
  source,
  selected,
  onChange,
  extendedUnlocked,
  locked = false,
  onUpgrade,
  disabled,
  always = false,
}) => {
  const counts = pictureSetCounts(source);
  const extended = selected === 'extended' && (!locked || extendedUnlocked);
  useEffect(() => {
    if (locked && !extendedUnlocked && selected === 'extended' && onChange) {
      onChange('basic');
    }
  }, [locked, extendedUnlocked, selected, onChange]);
  if (!always && (!counts || !counts.premium)) return null;
  const showUpgrade = extended && !extendedUnlocked && (!counts || counts.premium !== 0);
  return (
    <div className="gpPackSet">
      <div className="gpDurationRow" role="radiogroup" aria-label="Picture pack">
        <button
          type="button"
          role="radio"
          aria-checked={!extended}
          className={`gpDuration${!extended ? ' gpDuration--selected' : ''}`}
          disabled={disabled}
          onClick={() => onChange('basic')}
        >
          <span className="gpDuration__emoji" aria-hidden="true">🖼️</span>
          <span className="gpDuration__label">Basic</span>
          <span className="gpDuration__name">{countLabel(counts && counts.basic, 'Free pictures')}</span>
        </button>
        <button
          type="button"
          role="radio"
          aria-checked={extended}
          aria-label={locked ? 'Extended, locked' : 'Extended'}
          className={`gpDuration${extended ? ' gpDuration--selected' : ''}`}
          disabled={disabled}
          onClick={() => {
            if (locked) {
              if (onUpgrade) onUpgrade();
              return;
            }
            onChange('extended');
          }}
        >
          {locked && <span className="gpDuration__lock" aria-hidden="true">🔒</span>}
          <span className="gpDuration__emoji" aria-hidden="true">★</span>
          <span className="gpDuration__label">Extended</span>
          <span className="gpDuration__name">
            {counts && counts.total != null ? `All ${counts.total}` : 'All pictures'}
          </span>
        </button>
      </div>
      {showUpgrade && (
        <div className="gpPackSet__upgrade">
          <p>Extended pack includes every picture. Upgrade, or play it if your partner has Lexody Pro.</p>
          <FunButton variant="soft" size="small" emoji="★" text="Upgrade" onClick={onUpgrade} />
        </div>
      )}
    </div>
  );
};

export default PictureSetPicker;
